import { useState } from 'react';
import { CcTitle, CcCreateNewButton } from '../commonComponents/styledTexts';
import { DataFunctionsViewer } from '../components/dataFunctionsViewer';

export default function PageDataFunctions() {
  
    const [addEditMode, setAddEditMode] = useState(false);
  
    return <div>
          <CcTitle>Data Functions</CcTitle>

          <div className='mt-2' style={{height: 'calc(100% - 86px)'}}>
            <DataFunctionsViewer />
          </div>

    </div>
}